import React from 'react';
import styled from 'styled-components';
import Logo from '@catalogo/ui-americanas-desktop-svg/icon-logo.svg';
import { Nav } from '@catalogo/core-nav';

export const Legal = () => (
  <Container>
    <Logo fill="#f80032" height="20px" />
    <LegalContent>
      <Address>
        americanas s.a. / CNPJ: 00.776.574/0006-60 / Inscrição Estadual: 85.687.08-5 / Endereço Rua Sacadura Cabral, 102
        - Rio de Janeiro, RJ - 20081-902 /{' '}
        <Support href="https://www.americanas.com.br/hotsite/atendimento" title="fale com a gente">
          fale com a gente
        </Support>
        {' - atendimento.acom@americanas.com / fale com o RH: falecomrh@americanas.io'}
      </Address>
    </LegalContent>
    <MapContainer>
      <SiteMapLink to="https://www.americanas.com.br/mapa-do-site">mapa do site</SiteMapLink>
    </MapContainer>
  </Container>
);

const Support = styled.a`
  color: #666;
`;

const SiteMapLink = styled(Nav)`
  font-size: 12px;
  color: #666;
`;

const MapContainer = styled.div`
  margin: 20px 5px 0;
`;

const Container = styled.div`
  border-top: 1px solid #ccc;
  padding: 20px 0;
  background: #eaeaea;
  text-align: center;
`;

const Address = styled.address`
  font-style: normal;
  font-size: 1em;
  padding: 0;
  color: #666;
`;

const LegalContent = styled.div`
  padding: 20px 20px 0;
  font-size: 12px;
  text-align: center;
  clear: both;
  font-style: normal;
`;
